import React from "react";
import { List, Table } from "antd";
import type { ColumnType } from "antd/es/table";
import useIsMobile from "../../hooks/useIsMobile";

export function ShipmentTabHeading({ title, icon, subtitle, extra }: {
  title: string; icon?: React.ReactNode; subtitle?: string; extra?: React.ReactNode;
}) {
  return <div className="shipment-tab-heading"><div><h2>{icon}{title}</h2>{subtitle && <p>{subtitle}</p>}</div>{extra}</div>;
}

export function ShipmentMetricStrip({ items }: { items: { label: string; value: React.ReactNode; tone?: "positive" | "warning" | "negative" }[] }) {
  return <dl className="shipment-metric-strip">{items.map(item => <div key={item.label}><dt>{item.label}</dt>
    <dd className={item.tone ? `shipment-${item.tone}` : undefined}>{item.value}</dd></div>)}</dl>;
}

// Share column renderers so links, locks and permissions are identical on mobile.
export function ShipmentDataTable<T extends { id: number }>({ columns, rows, loading, emptyText, pageSize = 10, compact = false }: {
  columns: ColumnType<T>[]; rows: T[]; loading?: boolean; emptyText: React.ReactNode; pageSize?: number | false; compact?: boolean;
}) {
  const mobile = useIsMobile();
  if (!mobile) return <Table columns={columns} dataSource={rows} rowKey="id" loading={loading} size={compact ? "small" : "middle"}
    scroll={{ x: "max-content" }} pagination={pageSize === false ? false : { pageSize, showSizeChanger: true,
      showQuickJumper: true, showTotal: total => `${total} élément${total > 1 ? "s" : ""}` }} locale={{ emptyText }} />;
  return <List className="shipment-mobile-records" dataSource={rows} loading={loading} locale={{ emptyText }}
    pagination={pageSize === false ? false : { pageSize, size: "small", showSizeChanger: false }} renderItem={(row, index) =>
      <List.Item key={row.id}><article className="shipment-mobile-record"><dl>{columns.map((column, columnIndex) => {
        const value = typeof column.dataIndex === "string" ? (row as Record<string, unknown>)[column.dataIndex] : undefined;
        const rendered = column.render ? column.render(value, row, index) as React.ReactNode : value as React.ReactNode;
        return <div key={String(column.key || columnIndex)} className={column.key === "actions" || columnIndex < 2 ? "shipment-mobile-record-wide" : undefined}>
          <dt>{column.title as React.ReactNode}</dt><dd>{rendered ?? "—"}</dd></div>;
      })}</dl></article></List.Item>} />;
}
